
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 40v-5.6c0-1.133.292-2.175.875-3.125A5.832 5.832 0 019.2 29.1a29.698 29.698 0 016.3-2.325 27.515 27.515 0 018.5-.7c.667.05 1.333.125 2 .225a10.648 10.648 0 001.05 5.475A10.751 10.751 0 0030.7 36v4H6zm32 6l-3-3v-9.3a6.89 6.89 0 01-3.6-2.475C30.467 30.008 30 28.6 30 27c0-1.933.683-3.583 2.05-4.95C33.417 20.683 35.067 20 37 20c1.933 0 3.583.683 4.95 2.05C43.317 23.417 44 25.067 44 27c0 1.5-.425 2.833-1.275 4-.85 1.167-1.925 2-3.225 2.5L42 36l-3 3 3 3-4 4zM22 24c-2.2 0-4.083-.783-5.65-2.35C14.783 20.083 14 18.2 14 16s.783-4.083 2.35-5.65C17.917 8.783 19.8 8 22 8s4.083.783 5.65 2.35C29.217 11.917 30 13.8 30 16s-.783 4.083-2.35 5.65C26.083 23.217 24.2 24 22 24zm15 4c.567 0 1.042-.192 1.425-.575.383-.383.575-.858.575-1.425 0-.567-.192-1.042-.575-1.425C38.042 24.192 37.567 24 37 24c-.567 0-1.042.192-1.425.575-.383.383-.575.858-.575 1.425 0 .567.192 1.042.575 1.425.383.383.858.575 1.425.575z"}})])
          )
        }
      }
    